import { useMemo } from 'react';
import './WeekPlanner.scss';

const weekdays = ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo'];

export const WeekPlanner = (props: any) => {
	const { active, days, closed = [7] } = props;

	const _closed = useMemo(() => [
		7,
		...(closed || [])
	], closed);

	return (
		<div className="WeekPlanner">
			{weekdays.map((day, i) => (
				<div key={day} className={[
					'day',
					(i + 1 === active ? 'active ' : ''),
					(days?.indexOf(i + 1) === -1 ? 'disabled' : ''),
					(_closed?.indexOf(i + 1) > -1 ? 'disabled' : '')
				].join(' ')}>
					{day}
				</div>
			))}
		</div>
	);

};
